const ArticleTemplateGaps = {
	currentEditingLocale: null,
	currentBlockType: null,
	$propertyJoinsContainer: null,
	$templateTextContainer: null,
	$hiddenInputscontainer: null,
	$hiddenInputsPurgatory: null,
	gapBlocks: [],
	editBlockUniqId: null,
	removeButton: `<span class='Tag__remove-tag j-remove-block'>&times;</span>`,
	editButton: `<span class='Tag__edit-tag j-edit-block'></span>`,
	blankTags: {
		headline: `<div class='Tag Tag--in-playarea Tag--with-right-floating-button Tag--red' style='display: block; width: 33%'><span class='j-text-target'></span></div>`,
		fixed_text: `<div class='Tag Tag--in-playarea Tag--with-right-floating-button Tag--gray'><span class='j-text-target'></span></div>`,
		gap_option: `<div class='Tag Tag--in-playarea Tag--with-right-floating-button Tag--lila Tag--gap-option'><span class='j-text-target'></span></div>`,
		freeform_gap_option: `<div class='Tag Tag--in-playarea Tag--with-right-floating-button Tag--lila Tag--gap-option'><span class='j-text-target' style='background-color: rgba(223, 216, 234, 0.4); font-style: italic'></span></div>`, // NB the `background-color` is a lightened `@dark-pastel-7`
		gap_option_with_overlay: `<div class='Tag Tag--in-playarea Tag--with-right-floating-button Tag--lila OverlayContainer OverlayContainer--right'><div><span class='j-text-target'></span><div class='OverlayContainer__content'></div></div></div>`, // Can't have spaces or line breaks here
		freeform_gap: `<div class='Tag Tag--in-playarea Tag--with-right-floating-button Tag--blue-dark'><span class='j-text-target'></span></div>`,
	},

	init(presentData, editingLocale) {
		this.currentEditingLocale = editingLocale;
		this.gapBlocks = [];
		this.editBlockUniqId = null;
		// @ts-expect-error
		this.currentBlockType = $("input[name='building_block']:checked").val();
		// @ts-expect-error
		this.$templateTextContainer = $(
			`.article_template_texts [data-locale='${this.currentEditingLocale}']`,
		).find("textarea");
		// @ts-expect-error
		this.$propertyJoinsContainer = $(".j-property-joins-container");
		// @ts-expect-error
		this.$hiddenInputscontainer = $(".j-article-template-gap-inputs");
		// @ts-expect-error
		this.$hiddenInputsPurgatory = $(".j-article-template-gap-purgatory");

		$('input[name="building_block"]').on("click", (event) => {
			// @ts-expect-error
			$(event.currentTarget).closest("label").tab("show");
			// @ts-expect-error
			this.currentBlockType = $(event.currentTarget).val();
		});

		$(".j-add-property-join-link").on("click", this.appendPropertyJoinFields);
		$(".j-submit-block-button").on("click", this.handleSubmitButtonClick);
		$(document).on("click", ".j-edit-block", this.handleEditClick);
		$(document).on("click", ".j-remove-block", this.handleRemoveClick);

		this.observeChange("gapBlocks", this.handleGapChanges);

		// Add the unique ids for the data from Rails manually before
		presentData.forEach((block) => {
			block.uniqId = pp.viewHelpers.generateRandomId();
			block.content = block.content.replaceAll("\\r\\n", "\n");
		});
		this.gapBlocks = presentData;
	},

	handleGapChanges(oldval, newval) {
		// pp.log("new gap set", newval);
		$(".j-playarea").html("");
		// Wipe current input data
		this.addBlocksVisually(newval);
		this.collectedGapsData = this.buildTemplateTextAndCollectGapData(newval);
		this.buildTemplateGapsInput();
	},

	addBlocksVisually(newBlocks) {
		newBlocks.forEach((block, index) => {
			let $newTag;
			if (block.propertyJoinsData !== undefined) {
				$newTag = $(this.blankTags.gap_option_with_overlay);
				$(Object.keys(block.propertyJoinsData)).each(
					(propertyJoinIndex, propertyId) => {
						$newTag.find(".OverlayContainer__content").append(
							// @ts-expect-error
							`<strong>${block.propertyJoinsData[propertyId].name}</strong>: ${block.propertyJoinsData[propertyId].weight}<br>`,
						);
					},
				);
			} else if (block.isFreeformGapOption) {
				$newTag = $(this.blankTags.freeform_gap_option);
			} else {
				$newTag = $(this.blankTags[block.type]);
			}
			if (
				block.type == "gap_option" &&
				newBlocks.length > index + 1 &&
				newBlocks[index + 1].type != "gap_option"
			) {
				$newTag.addClass("Tag--gap-option--last");
			}
			$newTag
				.find("span.j-text-target")
				.html(block.content.replace("[[[-", "").replace("-]]]", ""));
			$newTag.attr("data-uniq-id", block.uniqId);
			$newTag.append(this.editButton);
			$newTag.append(this.removeButton);
			$(".j-playarea").append($newTag);
		});
	},

	handleEditClick(event) {
		// Remove `Tag--active` class from previously selected block that was not updated
		$(".Tag--active").removeClass("Tag--active");

		$(".j-edit-block, .j-remove-block")
			.prop("disabled", true)
			.addClass("Tag--disabled");

		const uniqId = parseInt(
			// @ts-expect-error
			$(event.currentTarget).closest(".Tag").attr("data-uniq-id"),
		);
		// @ts-expect-error
		pp.backend.formHelpers.articleTemplateGaps.editBlockUniqId = uniqId;

		$(`*[data-uniq-id='${uniqId}']`).addClass("Tag--active");
		$(".j-add-block-label").addClass("hidden");
		$(".j-update-block-label").removeClass("hidden");

		const block = pp.backend.formHelpers.articleTemplateGaps.gapBlocks.find(
			// @ts-expect-error
			(element) => element.uniqId === uniqId,
		);

		setTimeout(() => {
			// @ts-expect-error
			$(`#building_block_${block.type}`).trigger("click");
			// @ts-expect-error
			$(`#building_block_${block.type}`).closest("label").trigger("click");
		}, 10);

		// @ts-expect-error
		const $inputfield = $(`#building_block_${block.type}_pane`).find(
			"[name='block_content']",
		);
		// @ts-expect-error
		if (block.isFreeformGapOption) {
			// Need to remove the hacked-in marker for "this is a freeform gap option" again
			// @ts-expect-error
			block.content = block.content.replace("[[[-", "").replace("-]]]", "");
		}
		// @ts-expect-error
		$inputfield.val(block.content);

		// disable building_block checkboxes
		// @ts-expect-error
		$(`input[name='building_block']:not([value='${block.type}'])`).prop(
			"disabled",
			true,
		);
		$(`input[name='building_block']:disabled`)
			.parents("label")
			.find("span")
			.addClass("Tag--disabled");

		// disable multiselect + freeform checkboxes for gap options
		// @ts-expect-error
		if (block.type == "gap_option") {
			$(
				"input[type='checkbox'][name='article_template_gap[is_multiselect]",
			).prop("disabled", true);
			$(
				"input[type='checkbox'][name='article_template_gap[is_freeform_gap_option]",
			).prop("disabled", true);
			$(
				"input[type='checkbox'][name='article_template_gap[is_multiselect]",
				// @ts-expect-error
			).prop("checked", block.isMultiselect);
			$(
				"input[type='checkbox'][name='article_template_gap[is_freeform_gap_option]",
				// @ts-expect-error
			).prop("checked", block.isFreeformGapOption);
		}
	},

	handleRemoveClick(event) {
		const uniqId = parseInt(
			// @ts-expect-error
			$(event.currentTarget).closest(".Tag").attr("data-uniq-id"),
		);
		pp.backend.formHelpers.articleTemplateGaps.gapBlocks = _.filter(
			pp.backend.formHelpers.articleTemplateGaps.gapBlocks,
			function (block) {
				// @ts-expect-error
				if (block.uniqId != uniqId) {
					return true;
				}
				// This handles the case in which the user deletes a block that was "opened" for edit
				if (
					pp.backend.formHelpers.articleTemplateGaps.editBlockUniqId == uniqId
				) {
					pp.backend.formHelpers.articleTemplateGaps.editBlockUniqId = null;
					$(".j-add-block-label").removeClass("hidden");
					$(".j-update-block-label").addClass("hidden");
					// @ts-expect-error
					$(`#building_block_${block.type}_pane`)
						.find("[name='block_content']")
						.val("");
				}
				// This will only catch Article Template Gap *Options*, because only those have an `id` set in JS
				// @ts-expect-error
				if (block.id) {
					return !pp.backend.formHelpers.articleTemplateGaps.setGapOptionDeleteFlag(
						// @ts-expect-error
						block.id,
					); // Will return `true` if successful
				}
				// This will only catch Article Template *freeform Gaps*, because the Gap *Options* are caught by above condition
				// @ts-expect-error
				else if (block.gapId !== undefined) {
					return !pp.backend.formHelpers.articleTemplateGaps.setGapDeleteFlag(
						// @ts-expect-error
						block.gapId,
					); // Will return `true` if successful
				}
				return false;
			},
		);
	},

	setGapOptionDeleteFlag(recordId) {
		// @ts-expect-error
		const $optionDeleteFlagInput = this.$hiddenInputscontainer.find(
			`input[type='text'][name$='[_destroy]'][data-gap-option-id='${recordId}']`,
		);
		pp.log(
			"deleting gap option -- id, input:",
			recordId,
			$optionDeleteFlagInput,
		);
		if ($optionDeleteFlagInput.length) {
			// @ts-expect-error
			const $optionIdInput = this.$hiddenInputscontainer.find(
				`input[type='text'][name$='[id]'][value='${recordId}']`,
			);
			const gapId = $optionDeleteFlagInput.attr("data-gap-id");
			$optionDeleteFlagInput.detach().val(true);
			// @ts-expect-error
			this.$hiddenInputsPurgatory.append($optionDeleteFlagInput);
			// @ts-expect-error
			this.$hiddenInputsPurgatory.append($optionIdInput.detach());
			// @ts-expect-error
			this.$hiddenInputsPurgatory.append("<hr>");
			// No more Article Template Gap *Options* present, so mark the whole Article Template *Gap* to be destroyed
			if (
				// @ts-expect-error
				!this.$hiddenInputscontainer.find(
					`input[type='text'][name$='[_destroy]'][data-gap-option-id][data-gap-id='${gapId}']`,
				).length
			) {
				return pp.backend.formHelpers.articleTemplateGaps.setGapDeleteFlag(
					gapId,
				);
			}
			return true;
		} else {
			console.error("could not find ID field for", recordId);
			pp.log("could not find ID field for", recordId);
			return false;
		}
	},

	setGapDeleteFlag(recordId) {
		// @ts-expect-error
		const $gapDeleteFlagInput = this.$hiddenInputscontainer.find(
			`input[type='text'][name$='[_destroy]'][data-gap-id='${recordId}']`,
		);
		// @ts-expect-error
		const $gapIdInput = this.$hiddenInputscontainer.find(
			`input[type='text'][name$='[id]'][value='${recordId}']`,
		);
		pp.log(
			"deleting gap -- id, input:",
			recordId,
			$gapDeleteFlagInput,
			$gapIdInput,
		);
		$gapDeleteFlagInput.detach().val(true);
		// @ts-expect-error
		this.$hiddenInputsPurgatory.append($gapDeleteFlagInput);
		// @ts-expect-error
		this.$hiddenInputsPurgatory.append($gapIdInput.detach());
		// @ts-expect-error
		this.$hiddenInputsPurgatory.append("<hr>");
		// Remove the destroy flags for the Gap *Options*,they are not needed anymore, and would cause Rails to try to look up child records of just deleted parents
		// @ts-expect-error
		this.$hiddenInputsPurgatory
			.find(`input[type='text'][data-gap-option-id][data-gap-id='${recordId}']`)
			.remove();
		return true;
	},

	buildTemplateTextAndCollectGapData(newBlocks) {
		// @ts-expect-error
		this.$templateTextContainer.text("");
		// @ts-expect-error
		this.$hiddenInputscontainer.children().remove();

		// Test if there is anything to do
		if (!newBlocks.length) {
			// pp.log("returning, no blocks present");
			return [];
		}

		let collectedGapsData = [];
		let currentGapData;
		let lastBlock;

		newBlocks.forEach((block) => {
			// pp.log("at block", block);
			let htmlToAppend = "";

			// Special case: current block is *not* a Gap Option or freeform gap, but the last one was
			if (
				block.type != "gap_option" &&
				lastBlock &&
				["gap_option", "freeform_gap"].includes(lastBlock.type)
			) {
				collectedGapsData.push(currentGapData);
			}

			switch (block.type) {
				case "headline":
					htmlToAppend = `<h4>${block.content}</h4>`;
					break;

				case "fixed_text":
					htmlToAppend = block.content;
					break;

				case "gap_option":
					const immediatelyAdjacentGaps =
						lastBlock !== undefined &&
						lastBlock.gapId &&
						block.gapId &&
						lastBlock.gapId != block.gapId;
					// NB always force the creation of a new gap if the `lastBlock` is `isFreeformGapOption`
					if (
						!lastBlock ||
						lastBlock.type != "gap_option" ||
						lastBlock.isFreeformGapOption ||
						immediatelyAdjacentGaps
					) {
						if (immediatelyAdjacentGaps) {
							pp.log("pushing immediately adjacent gap", currentGapData);
							collectedGapsData.push(currentGapData);
						}
						htmlToAppend = "[GAP]";
						// @ts-expect-error
						const currentTextLength = this.$templateTextContainer
							.text()
							.replaceAll(/\n/g, "\\r\\n").length;

						currentGapData = {
							id: block.gapId,
							gapStart: currentTextLength,
							gapEnd: currentTextLength + "[GAP]".length,
							isMultiselect: block.gapIsMultiselect,
							options: {},
						};
						// pp.log("setting gap option:", currentGapData.gapStart, currentGapData.gapEnd);
					}
					currentGapData.options[block.content] = {
						id: block.id, // might be undefined for newly inserted blocks
						propertyJoinsData: block.propertyJoinsData,
					};
					// pp.log("currentGapData now", currentGapData);
					break;

				case "freeform_gap":
					htmlToAppend = block.content;
					// @ts-expect-error
					const currentTextLength = this.$templateTextContainer
						.text()
						.replaceAll(/\n/g, "\\r\\n").length;
					currentGapData = {
						id: block.gapId,
						gapStart: currentTextLength,
						// Use `replaceAll(/\n/g, "\\r\\n")` for the rare cases where the user managed to sneak in a line break
						// (should actually never happen because normal text inputs should not allow line breaks).
						gapEnd:
							currentTextLength +
							block.content.replaceAll(/\n/g, "\\r\\n").length,
					};
					// pp.log("setting freeform gap:", currentGapData.gapStart, currentGapData.gapEnd);
					break;

				default:
					console.error("Unknown type in block", block);
			}

			// pp.log("to append", htmlToAppend, htmlToAppend.length)
			// pp.log("/\\n/g ->", htmlToAppend.replaceAll(/\n/g, "\\r\\n"), htmlToAppend.replaceAll(/\n/g, "\\r\\n").length);
			// pp.log("\\r\\n ->", htmlToAppend.replaceAll("\r\n", "\\r\\n"), htmlToAppend.replaceAll("\r\n", "\\r\\n").length);
			// @ts-expect-error
			this.$templateTextContainer.text(
				// @ts-expect-error
				this.$templateTextContainer.text() + htmlToAppend,
			);
			lastBlock = block;
		});

		if (this.editBlockUniqId == null) {
			$(`input[name='building_block']`).prop("disabled", false);

			let disableIsMultipleCheckbox = false;
			let disabledFreeformGapOptionCheckbox = true;
			let disableOtherBlocks = false;
			// Extra special case: *last* block was a Gap Option or freeform gap
			// pp.log("last", lastBlock);
			if (
				lastBlock &&
				// @ts-expect-error
				["gap_option", "freeform_gap"].includes(lastBlock.type)
			) {
				collectedGapsData.push(currentGapData);
				// @ts-expect-error
				if (lastBlock.type == "gap_option") {
					disableIsMultipleCheckbox = true;
					// Check if there is a single trailing gap option and force the user to add another option as the next building block,
					// because having a gap with just one option doesn't make sense
					disableOtherBlocks =
						newBlocks.length == 1 ||
						newBlocks[newBlocks.length - 2].type != "gap_option";
					// @ts-expect-error
					if (lastBlock.isFreeformGapOption) {
						$(
							"input[type='checkbox'][name='article_template_gap[is_freeform_gap_option]",
						).prop("checked", false);
						disableOtherBlocks = false;
						// @ts-expect-error
					} else if (!lastBlock.gapIsMultiselect) {
						disabledFreeformGapOptionCheckbox = false;
					}
				}
			}
			// pp.log("diss", $("input[name='building_block']:not([value='gap_option'])"), disableOtherBlocks, $("input[name='building_block']:disabled"));
			$("input[name='building_block']:not([value='gap_option'])").prop(
				"disabled",
				disableOtherBlocks,
			);
			$(".j-edit-block").prop("disabled", disableOtherBlocks); // disable edit btn if the user needs to add a second gap option first
			if (disableOtherBlocks) {
				$(`#building_block_gap_option`).trigger("click");
			}

			$("input[name='building_block']:disabled")
				.parents("label")
				.find("span")
				.addClass("Tag--disabled");
			$("input[name='building_block']:not(:disabled)")
				.parents("label")
				.find("span")
				.removeClass("Tag--disabled");
			// Only let the user set `is_multiselect` on the very first gap option, because it actually belongs to the template gap
			$(
				"input[type='checkbox'][name='article_template_gap[is_multiselect]",
			).prop("disabled", disableIsMultipleCheckbox);
			$(
				"input[type='checkbox'][name='article_template_gap[is_freeform_gap_option]",
			).prop("disabled", disabledFreeformGapOptionCheckbox);

			// Show the "fixed text" tab pane to suggest to the user that the gap option has been closed by the freeform gap option
			// @ts-expect-error
			if (lastBlock.isFreeformGapOption) {
				$("#building_block_fixed_text").closest("label").trigger("click");
				$("#building_block_fixed_text").trigger("click");
			}
		}

		return collectedGapsData;
	},

	buildTemplateGapsInput() {
		// pp.log("buildTemplateGapsInput:", this.collectedGapsData);
		$(this.collectedGapsData).each((index, elem) => {
			const gapId = elem.id || pp.viewHelpers.generateRandomId();
			const gapInputName = `article[template_gaps_attributes][${gapId}]`;
			// @ts-expect-error
			this.$hiddenInputscontainer.append(
				`<input type='text' name='${gapInputName}[language]' value='${this.currentEditingLocale}'>`,
			);
			// @ts-expect-error
			this.$hiddenInputscontainer.append(
				`<input type='text' name='${gapInputName}[gap_start]' value='${elem.gapStart}'>`,
			);
			// @ts-expect-error
			this.$hiddenInputscontainer.append(
				`<input type='text' name='${gapInputName}[gap_end]' value='${elem.gapEnd}'>`,
			);
			// @ts-expect-error
			this.$hiddenInputscontainer.append(
				`<input type='text' name='${gapInputName}[is_multiselect]' value='${elem.isMultiselect || false}'>`,
			); // `|| false` in case the fields are not shown
			if (elem.id) {
				// @ts-expect-error
				this.$hiddenInputscontainer.append(
					`<input type='text' name='${gapInputName}[id]' value='${elem.id}'>`,
				);
				// @ts-expect-error
				this.$hiddenInputscontainer.append(
					`<input type='text' name='${gapInputName}[_destroy]' data-gap-id='${elem.id}' value='false'>`,
				);
				// @ts-expect-error
				this.$hiddenInputscontainer.append("<hr>");
			}
			if (elem.options !== undefined) {
				this.buildTemplateGapOptionsInput(gapInputName, elem.options, gapId);
			}
		});
	},

	buildTemplateGapOptionsInput(gapInputName, gapOptionsHash, gapId) {
		// pp.log("buildTemplateGapOptionsInput", gapOptionsHash);
		$(Object.keys(gapOptionsHash)).each((optionIndex, optionName) => {
			// @ts-expect-error
			const optionData = gapOptionsHash[optionName];
			const gapOptionInputName =
				gapInputName +
				`[gap_options_attributes][${optionData.id || optionIndex}]`;
			// @ts-expect-error
			this.$hiddenInputscontainer.append(
				`<input type='text' name='${gapOptionInputName}[name]' value='${optionName}'>`,
			);
			if (optionData.id) {
				// @ts-expect-error
				this.$hiddenInputscontainer.append(
					`<input type='text' name='${gapOptionInputName}[id]' data-gap-id='${gapId}' data-gap-option-id='${optionData.id}' value='${optionData.id}'>`,
				);
				// @ts-expect-error
				this.$hiddenInputscontainer.append(
					`<input type='text' name='${gapOptionInputName}[_destroy]' data-gap-id='${gapId}' data-gap-option-id='${optionData.id}' value='false'>`,
				);
				// @ts-expect-error
				this.$hiddenInputscontainer.append("<hr>");
			}

			if (optionData.propertyJoinsData !== undefined) {
				this.buildPropertyJoinsInput(
					gapOptionInputName,
					optionData.propertyJoinsData,
				);
			}
		});
	},

	buildPropertyJoinsInput(gapOptionInputName, propertyJoinsHash) {
		// pp.log("buildPropertyJoinsInput", propertyJoinsHash);
		$(Object.keys(propertyJoinsHash)).each((propertyJoinIndex, propertyId) => {
			const gapOptionPropJoinInputName =
				gapOptionInputName +
				`[article_template_gap_option_property_joins_attributes][${propertyJoinIndex}]`;
			// @ts-expect-error
			this.$hiddenInputscontainer.append(
				`<input type='text' name='${gapOptionPropJoinInputName}[property_id]' value='${propertyId}'>`,
			);
			// @ts-expect-error
			this.$hiddenInputscontainer.append(
				// @ts-expect-error
				`<input type='text' name='${gapOptionPropJoinInputName}[weight]' value='${propertyJoinsHash[propertyId].weight}'>`,
			);
			// @ts-expect-error
			if (propertyJoinsHash[propertyId].joinRecordId !== undefined) {
				// @ts-expect-error
				this.$hiddenInputscontainer.append(
					// @ts-expect-error
					`<input type='text' name='${gapOptionPropJoinInputName}[id]' value='${propertyJoinsHash[propertyId].joinRecordId}'>`,
				);
				// @ts-expect-error
				this.$hiddenInputscontainer.append("<hr>");
			}
		});
	},

	handleSubmitButtonClick() {
		const module = pp.backend.formHelpers.articleTemplateGaps;
		const $inputfield = $(
			`#building_block_${module.currentBlockType}_pane`,
		).find("[name='block_content']");
		const inputContent = $inputfield.val();
		if (
			["headline", "gap_option", "freeform_gap"].includes(
				// @ts-expect-error
				module.currentBlockType,
			) &&
			// @ts-expect-error
			!inputContent.trim().length
		) {
			return;
		}

		// Re-enable all options for now (might be re-disabled again via `disableOtherBlocks` in `buildTemplateTextAndCollectGapData`)
		$(`input[name='building_block']`).prop("disabled", false);
		$(`input[name='building_block']`)
			.parents("label")
			.find("span")
			.removeClass("Tag--disabled");

		let dupedGapBlocks = Object.assign([], module.gapBlocks);
		let gapBlocksIdx;

		if (module.editBlockUniqId) {
			gapBlocksIdx = dupedGapBlocks.findIndex(
				(element) => element.uniqId === module.editBlockUniqId,
			);
		} else {
			gapBlocksIdx = dupedGapBlocks.length;
		}

		// Simply add the new fixed text to the last block if it's already of type `fixed_text`
		if (
			module.currentBlockType == "fixed_text" &&
			gapBlocksIdx &&
			dupedGapBlocks[gapBlocksIdx - 1].type == "fixed_text"
		) {
			dupedGapBlocks[gapBlocksIdx - 1].content += " " + inputContent; // Assume that we want a space before the new input
		} else {
			let newGapEntry = {
				type: module.currentBlockType,
				content: inputContent,
				uniqId: module.editBlockUniqId
					? module.editBlockUniqId
					: pp.viewHelpers.generateRandomId(),
			};
			if (module.currentBlockType == "gap_option") {
				// This input will be disabled for all but the first added option but that won't matter
				newGapEntry.gapIsMultiselect = $(
					"input[name='article_template_gap[is_multiselect]']:checked",
				).val();
				if (
					$(
						"input[type='checkbox'][name='article_template_gap[is_freeform_gap_option]",
					).prop("checked")
				) {
					newGapEntry.isFreeformGapOption = true;
					newGapEntry.content = `[[[-${newGapEntry.content}-]]]`;
				}
				// Collect the data for pertained Properties
				if (
					// @ts-expect-error
					module.$propertyJoinsContainer.find(".Form__hash-field__kv-pair")
						.length
				) {
					newGapEntry.propertyJoinsData = {};
					// @ts-expect-error
					module.$propertyJoinsContainer
						.find(".Form__hash-field__kv-pair")
						.each((index, elem) => {
							const propId = $(elem).find("select").val();
							const weight = $(elem).find("input").val();
							const name = $(elem).find("option:selected").text();
							// @ts-expect-error
							newGapEntry.propertyJoinsData[propId] = {
								// @ts-expect-error
								weight: parseFloat(weight),
								name: name,
							};
						});
				}
			}

			if (module.editBlockUniqId) {
				dupedGapBlocks[gapBlocksIdx].content = newGapEntry.content;
				module.editBlockUniqId = null;
				$(".j-edit-block, .j-remove-block")
					.prop("disabled", false)
					.removeClass("Tag--disabled");
			} else {
				dupedGapBlocks.push(newGapEntry);
			}
		}
		// @ts-expect-error
		module.gapBlocks = dupedGapBlocks;

		$inputfield.val("");
		// @ts-expect-error
		module.$propertyJoinsContainer.children().remove(); // Remove the Property join fields
		$(".j-add-block-label").removeClass("hidden");
		$(".j-update-block-label").addClass("hidden");
	},

	appendPropertyJoinFields() {
		// @ts-expect-error
		pp.backend.formHelpers.articleTemplateGaps.$propertyJoinsContainer.append(
			this.dataset.content,
		);
	},
};

export default ArticleTemplateGaps;
